'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Key store interface for `InMemorySigner`.
 */
class KeyStore {
}
exports.KeyStore = KeyStore;
